export class EventMessageModel 
{
    public RefId: number;
    public Message :string;
    public FromDate: Date;
    public ToDate: Date;
    public MessageType: string;
    public IsActive : boolean;
    public TypeId: number;
}